import { Chip } from "@mui/material";

/** Red "Live" chip for a bet placed while its match was already live — not a pre-match pick, so predictions ignore it. */
export default function LiveBetBadge(props: { live?: boolean }) {
    if (!props.live) return null;
    return (
        <Chip
            label="Live"
            color="error"
            size="small"
            title="Placed while the match was already live"
            sx={{ ml: 1, height: 20, fontSize: '0.7rem', fontWeight: 700, verticalAlign: 'middle' }}
        />
    );
}
